import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import styles from './Accordion.st.css';
import AccordionItem from './AccordionItem';

var Accordion = /*#__PURE__*/function (_React$Component) {
  _inherits(Accordion, _React$Component);

  var _super = _createSuper(Accordion);

  function Accordion(props) {
    var _this;

    _classCallCheck(this, Accordion);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "_findOpenIndexes", function (items) {
      return items.map(function (item, index) {
        return item.open ? index : null;
      }).filter(function (index) {
        return index !== null;
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_compareOpenItems", function (currentItems, prevItems) {
      if (prevItems.length !== currentItems.length) {
        return false;
      }

      for (var i = 0; i < prevItems.length; i++) {
        if (prevItems[i].open !== currentItems[i].open) {
          return false;
        }
      }

      return true;
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      if (!_this._compareOpenItems(_this.props.items, prevProps.items)) {
        _this.setState({
          openIndexes: _this._findOpenIndexes(_this.props.items)
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "_toggle", function (index) {
      return function () {
        return _this.setState(function (_ref) {
          var openIndexes = _ref.openIndexes;
          return {
            openIndexes: openIndexes.includes(index) ? openIndexes.filter(function (i) {
              return i !== index;
            }) : _this.props.multiple ? [].concat(_toConsumableArray(openIndexes), [index]) : [index]
          };
        });
      };
    });

    _this.state = {
      openIndexes: _this._findOpenIndexes(_this.props.items)
    };
    return _this;
  }

  _createClass(Accordion, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var openIndexes = this.state.openIndexes;
      var _this$props = this.props,
          dataHook = _this$props.dataHook,
          items = _this$props.items,
          skin = _this$props.skin,
          hideShadow = _this$props.hideShadow;
      return /*#__PURE__*/React.createElement("div", {
        "data-hook": dataHook
      }, items.map(function (item, index, allItems) {
        return /*#__PURE__*/React.createElement(AccordionItem, _extends({}, styles('item', {
          last: index === allItems.length - 1
        }, _this2.props), {
          key: index,
          onToggle: _this2._toggle(index)
        }, item, {
          open: openIndexes.includes(index),
          skin: skin,
          hideShadow: hideShadow
        }));
      }));
    }
  }]);

  return Accordion;
}(React.Component);

_defineProperty(Accordion, "displayName", 'Accordion');

_defineProperty(Accordion, "propTypes", {
  /** Applied as data-hook HTML attribute that can be used to create driver in testing */
  dataHook: PropTypes.string,

  /** allow multiple rows to be opened simultaneously */
  multiple: PropTypes.bool,

  /** Accordion skin color */
  skin: PropTypes.oneOf(['standard', 'light']),

  /** Hide Accordion shadow effect */
  hideShadow: PropTypes.bool,

  /** accordion items nodes */
  items: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.node,
    icon: PropTypes.node,
    children: PropTypes.node,
    expandLabel: PropTypes.node,
    collapseLabel: PropTypes.node,
    buttonType: PropTypes.oneOf(['textButton', 'button'])
  }))
});

_defineProperty(Accordion, "defaultProps", {
  items: [],
  multiple: false,
  skin: 'standard',
  hideShadow: false
});

export default Accordion;